const openItems = [];

/**
 * @param {NodeList} lists
 */
export default function initializeSubLists(lists) {
  document.addEventListener('click', ({ target }) => {
    let containing = false;

    lists.forEach((list) => {
      if (list.contains(target)) {
        containing = true;
      }
    });

    if (openItems.length !== 0 && containing === false) {
      openItems.forEach((item) => {
        item.classList.remove('--open');
      });
    }
  });

  lists.forEach((list) => {
    const itemsWithSubs = list.querySelectorAll('.-with-sub');

    if (!itemsWithSubs) {
      return;
    }

    itemsWithSubs.forEach((item) => {
      item.addEventListener('click', function () {
        if (this.classList.contains('--open')) {
          this.classList.remove('--open');
          return;
        }

        if (openItems.length !== 0) {
          openItems.forEach((item) => {
            item.classList.remove('--open');
          });
        }

        this.classList.add('--open');
        openItems.push(this);
      });
    });
  });
}
